module.exports = __webpack_public_path__ + "img/load_off.ab3c6871.svg";